export default __webpack_public_path__ + "assets/100_Homes_1x.gif";